import React from 'react';

const Copyright = () => {
    return (
        <div className="copyright">
            <p className="text-center">© { new Date().getFullYear() } Botany Physio</p>
        </div>
    );
};

export default Copyright;
